import { Trans } from '@lingui/macro'

import * as React from 'react'

import { TFPaymentMethod } from '~graphql/generated/clientGraphql'
import { isDefined } from '~logic/helpers/isDefined'
import { Text } from '~ui/components/typography/Text/Text'

import { isPostPaidMethod } from '../segments/PaymentMethods'

type TOptions = {
  isMobile: boolean
  paymentMethod: Nullable<TFPaymentMethod>
}

/**
 * Use different submit button labels
 * based on whether the customer will be navigated to the SubmittedScreen (and pay on takeover)
 * or into an online payment gateway (prepay is method selected).
 */
export const useSubmitButtonLabel = ({ isMobile, paymentMethod }: TOptions) => {
  const navigatingToOnlinePayment =
    isDefined(paymentMethod) && !isPostPaidMethod(paymentMethod.paymentGate.enum)

  // the "with obligation to pay" part is strongly suggested by the ČOI
  // it is based on EU law
  const label = React.useMemo(() => {
    if (!navigatingToOnlinePayment) {
      return (
        <>
          <Text as={`span`} inherit>
            <Trans>order</Trans>
          </Text>
          <br />
          <Text as={`span`} inherit fontSize={`s12`} whiteSpace={`nowrap`}>
            <Trans>with obligation to pay</Trans>
          </Text>
        </>
      )
    }

    return isMobile ? <Trans>pay now</Trans> : <Trans>proceed to payment</Trans>
  }, [isMobile, navigatingToOnlinePayment])

  return label
}
